import { render, staticRenderFns } from "./BackupCodes2FA.vue?vue&type=template&id=d7de4506&scoped=true&"
import script from "./BackupCodes2FA.vue?vue&type=script&lang=js&"
export * from "./BackupCodes2FA.vue?vue&type=script&lang=js&"
import style0 from "./BackupCodes2FA.vue?vue&type=style&index=0&id=d7de4506&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7de4506",
  null
  
)

export default component.exports